import React, { Component } from "react";
import TopBar from "../../component/projectDetail/TopBar";
import Banner from "../../component/projectDetail/Banner";
import RightPanel from "../../component/projectDetail/RightPanel";
import ProjectActivity from "../../component/feeds/ProjectActivity";
import { connect } from "react-redux";
import * as _ from "lodash";
import { Link } from "react-router-dom";
import alertPopUp from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import { authService } from "../../../auth";
import OrganizationAdmin from "../../../commons/OrganizationAdmin";

const ErorrMsgPopUp = withReactContent(alertPopUp)
class CentralPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
        userData: authService.getUserDetailsFromLocalStorage(),
        postCount: 0,
    }
  }

  getPostCount = (count) => {
    this.setState({
      postCount: count
    })
  }

  render() {
    return (
      <div className="col-md-9">
        <div className="projectinn nothidden projdetailscont">
          <Banner {...this.props} />
          {this.props.projectDetail &&
            !_.isUndefined(this.props.projectDetail.demolished) &&
            this.props.projectDetail.demolished === false && (
              <TopBar {...this.props} />
            )}

          {this.props.userId && <OrganizationAdmin userId={this.props.userId} />}

          <div className="projdetlswrap">
            <div className="row">
              <div className="col-lg-9">
                {/* <div className="circMemInviteTabwrap" style={{ marginTop: this.props.projectDetail.editPermission ? "26px" : "18px", display: 'flex', justifyContent: "flex-end", marginBottom: this.props.projectDetail.editPermission ? "0" : "18px", }}>
                  {this.state.postCount !== 0 && this.props.projectDetail?.id &&
                    <div className="posthnavtab" style={{ boxShadow: "none", borderBottom: "none"}}>
                      <a href="javascript:void(0)" className="viewAllAct btn-primary btn" onClick={() => this.checkPostDataConfig()}>
                            <i className="iAddPost" style={{marginRight: "5px"}} />Post
                      </a>
                    </div>
                  }
                </div> */}
                {/* {this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.wallAvailable && this.props.projectDetail.project.type !== "JOB" && 
                  <div className="invtButtns microcommfeed mt-2 align-item-end p-0 mb-2 mr-2 d-flex">
                      <Link to={"/project/feeds/" + this.props.slug + "/grid"} className="viewAllAct">
                          <i className="iGrid1" /> <span>View All Activity</span>
                      </Link>
                  </div>
                } */}
                <div className="projdtlsfeedsinn mt-4">
                  <ProjectActivity project={this.props.projectDetail} getPostCount={this.getPostCount} />
                </div>
              </div>

              <RightPanel {...this.props} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    project: state.showAllReducer,
    applications: state.applications,
  };
};
export default connect(mapStateToProps, null)(CentralPanel);
